import core from './core';
var dataRelay = core(fetch, 'React Native SDK');
export default dataRelay;
